import { render, staticRenderFns } from "./CantOrder.vue?vue&type=template&id=4e5340ea&scoped=true&"
import script from "./CantOrder.vue?vue&type=script&lang=js&"
export * from "./CantOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5340ea",
  null
  
)

export default component.exports